import "./../areaChart.css";

import * as d3 from "d3";
import React, { useEffect } from "react";

interface DemandVersusTimeLineProps {
    xScale: d3.ScaleLinear<number, number>;
    yScale: d3.ScaleLinear<number, number>;
    data: { periodName: string; periodNumber: number; demandCount: number }[];
    mobile: boolean;
    d3Id: string;
}

export const DemandVersusTimeLine = (props: DemandVersusTimeLineProps) => {
    const { xScale, yScale, data, mobile, d3Id } = props;
    useEffect(() => {
        //drawing the line
        const line = d3
            .line()
            .x(d =>
                xScale((d as unknown as { periodNumber: number }).periodNumber)
            )
            .y(d =>
                yScale((d as unknown as { demandCount: number }).demandCount)
            );

        //appending the line to the chart
        d3.select(`#${d3Id}`)
            .selectAll(".lines")
            .selectAll(".line-group")
            .data([data])
            .enter()
            .append("svg:path")
            .attr("class", "line")
            .attr("d", d =>
                line(
                    d as unknown as [
                        demandCount: number,
                        periodNumber: number
                    ][]
                )
            )
            .style("stroke", "#54d2c7")
            .style("stroke-width", 0.5)
            .style("fill", "none");

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <g className="lines"></g>;
};
